export default __webpack_public_path__ + "static/media/doctor-removebg-preview.6c6c7794.png";